var curry = require('curry');
var compose = require('lodash.compose');
var rgba = require('./rgba.js');
var reverse = require('../../reverse.js');
var fillRegion = curry(require('./fillRegion.js'));
var addRegionToMap = curry(require('./addRegionToMap.js'));
var findRegionById = curry(require('./findRegionById.js'));

module.exports = function loadRegionsToMap(map, items) {
	ymaps.regions.load('RU', {
    	lang: 'ru',
	    quality: 3
  	}).then(function (result) {
  		// debugger;
	    reverse(items).forEach(function(item) {
	    	item.regions = item.regions
	    		.map(compose(
	    			fillRegion(item.img ? rgba(item.color, 0.5) : rgba()),
	    			addRegionToMap(map),
	    			findRegionById(result.geoObjects)
    			));
    	});
  	});

  	return items;
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/loadRegionsToMap.js
 **/